<!-- リンクボタン -->
<template>
  <router-link
    v-if="linkName === `CrlyOtherPage`"
    class="crly-a-common-btn-link-main-color"
    :class="{ '--disabled': disabled }"
    :to="{ name: linkName, query: { other_id: otherId }, hash: hash }"
    :target="target"
    @click.native="onClick"
  >
    <span>{{ label }}</span>
  </router-link>
  <router-link
    v-else
    class="crly-a-common-btn-link-main-color"
    :class="{ '--disabled': disabled }"
    :to="{ name: linkName }"
    :target="target"
    @click.native="onClick"
  >
    <span>{{ label }}</span>
  </router-link>
</template>

<script>
export default {
  name: "CrlyAtomsCommonBtnLinkMainColor",
  props: {
    label: {
      type: String,
      default: ""
    },
    linkName: {
      type: String,
      default: ""
    },
    otherId: {
      type: String,
      default: ""
    },
    hash: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/btn/linkMainColor.scss";
</style>
